<div class="filter-container">
  <div class="filter-toggle">
    <span
      class="filter-type active"
      [ngClass]="{ active: this.showingSearch }"
      id="search"
      (click)="setSearchSection()"
      tabindex="0"
      (keydown.enter)="setSearchSection()"
      >Search</span
    >
    <span
      class="filter-type"
      [ngClass]="{ active: !this.showingSearch }"
      id="filter"
      (click)="setFilterSection()"
      tabindex="0"
      (keydown.enter)="setFilterSection()"
      >Filter</span
    >
  </div>
  <div class="filter-main-section">
    <!-- Global Search -->
    @if (this.showingSearch) {
      <div class="search-section">
        <div class="searchbar-container">
          <div class="search-input-container">
            <input
              type="text"
              placeholder="{{ tableDetails?.searchPlaceholder }}"
              id="searchInput"
              [(ngModel)]="globalSearch"
              (keyup.enter)="runSearch()"
            />
            <span class="material-symbols-outlined search-icon">search</span>
            @if (this.hasActiveFilters) {
              <span class="filter-active-text"
                ><img src="../../../../assets/images/Warning.svg" alt="warning icon" /> Active
                Filters will be cleared</span
              >
            }
          </div>
          <div
            class="button button-green"
            id="searchBtn"
            (click)="runSearch()"
            tabindex="0"
            (keydown.enter)="runSearch()"
            [ngClass]="{ disabled: isLoader() }"
          >
            Search
          </div>
        </div>
      </div>
    }

    <!-- Filter by individual columns -->
    @if (!this.showingSearch) {
      <div class="filter-section">
        <div class="filter-button-container">
          <div
            class="dropdown filter-dropdown"
            ngbDropdown
            #dropdown="ngbDropdown"
            (openChange)="onFilterDropdownStateChange($event)"
          >
            <div
              class="button button-clear"
              role="button"
              id="filtersDropdown"
              ngbDropdownToggle
              aria-expanded="false"
              data-bs-auto-close="outside"
              (keydown)="onKeyDown($event)"
              tabindex="0"
              [ngClass]="{ disabled: isLoader() }"
            >
              <span class="material-symbols-outlined filter-icon">filter_list</span>
              Add Filter
            </div>
            <div class="dropdown-menu" ngbDropdownMenu>
              <div class="dropdown-left">
                <ul>
                  @for (column of columns; track column) {
                    <ng-container>
                      @if (column.filter) {
                        <li
                          #filterOption
                          class="dropdown-item"
                          ngbDropdownItem
                          (click)="setVisible(column)"
                          tabindex="0"
                          (keydown.enter)="setVisible(column)"
                          [ngClass]="{
                            hidden: column?.filter?.active,
                            active: column?.filter?.visible,
                          }"
                        >
                          {{ column.name }}
                        </li>
                      }
                    </ng-container>
                  }
                </ul>
              </div>
              @if (showingNestedDropdown()) {
                <div class="dropdown-right" id="filter1">
                  @for (column of columns; track column) {
                    <div
                      class="filter-options-container"
                      [ngClass]="{ hidden: !column?.filter?.visible }"
                    >
                      @if (column?.filter) {
                        <ng-container>
                          <!-- Filter type: string search -->
                          @if (column?.filter?.type === 'string' && column?.filter?.visible) {
                            <div class="filter-selection-container">
                              <label>{{ column.name }}:</label>
                              <input
                                #input
                                type="text"
                                class="filter-search"
                                placeholder=""
                                (input)="this.cdr.detectChanges()"
                              />
                              <div
                                class="button button-green"
                                (click)="setStringFilter(column, input.value)"
                                tabindex="0"
                                (keydown.enter)="setStringFilter(column, input.value)"
                                [ngClass]="input.value === '' ? 'disabled' : ''"
                              >
                                Set Filter
                              </div>
                            </div>
                          }

                          <!-- Filter type: email search -->
                          @if (column?.filter?.type === 'email' && column?.filter?.visible) {
                            <div class="filter-selection-container">
                              <label>{{ column.name }}:</label>
                              <input
                                #input
                                type="email"
                                class="filter-search"
                                placeholder=""
                                (input)="this.cdr.detectChanges()"
                              />
                              <div
                                class="button button-green"
                                (click)="setStringFilter(column, input.value)"
                                tabindex="0"
                                (keydown.enter)="setStringFilter(column, input.value)"
                                [ngClass]="input.value === '' ? 'disabled' : ''"
                              >
                                Set Filter
                              </div>
                            </div>
                          }

                          <!-- Filter type: checkboxes -->
                          @if (
                            column?.filter?.type === 'multipleChoice' && column?.filter?.visible
                          ) {
                            <div class="filter-selection-container">
                              <label>{{ column.name }}:</label>
                              <ul>
                                @for (option of column?.filter?.options; track option) {
                                  <li>
                                    <label class="custom-check-container"
                                      >{{ option.label }}
                                      <input
                                        [(ngModel)]="option.checked"
                                        type="checkbox"
                                        value="{{ option.key }}"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                  </li>
                                }
                              </ul>
                              <div
                                class="button button-green"
                                (click)="setCheckboxFilter(column, $event)"
                                tabindex="0"
                                (keydown.enter)="setCheckboxFilter(column, $event)"
                                [class.disabled]="!anyChecked(column)"
                              >
                                Set Filter
                              </div>
                            </div>
                          }

                          <!-- Filter type: number amount (exact, min, max) -->
                          @if (column?.filter?.type === 'amount' && column?.filter?.visible) {
                            <div class="filter-selection-container">
                              <label>
                                <input
                                  type="radio"
                                  name="amountType"
                                  value="exact"
                                  #exactSelected
                                  checked
                                  (change)="changeAmountSelection(exactSelected, min, max, exact)"
                                />
                                Exact Value
                              </label>
                              <label>Amount</label>
                              <input
                                #exact
                                type="number"
                                class="filter-search"
                                placeholder=""
                                [disabled]="!exactSelected.checked"
                                (input)="this.cdr.detectChanges()"
                              />
                              <div class="or-container">
                                <hr />
                                <span>OR</span>
                              </div>
                              <label>
                                <input
                                  type="radio"
                                  name="amountType"
                                  value="range"
                                  #rangeSelected
                                  (change)="changeAmountSelection(rangeSelected, min, max, exact)"
                                />
                                Amount Range
                              </label>
                              <label>From</label>
                              <input
                                #min
                                type="number"
                                class="filter-search"
                                placeholder=""
                                [disabled]="!rangeSelected.checked"
                                (input)="this.cdr.detectChanges()"
                              />
                              <label>To</label>
                              <input
                                #max
                                type="number"
                                class="filter-search mb-3"
                                placeholder=""
                                [disabled]="!rangeSelected.checked"
                                (input)="this.cdr.detectChanges()"
                              />
                              <div
                                class="button button-green"
                                (click)="setAmountFilter(column, exact.value, min.value, max.value)"
                                tabindex="0"
                                (keydown.enter)="
                                  setAmountFilter(column, exact.value, min.value, max.value)
                                "
                                [class.disabled]="
                                  min.value === '' && max.value === '' && exact.value === ''
                                "
                              >
                                Set Filter
                              </div>
                            </div>
                          }

                          <!-- Filter type: date (last 7,14, 30, etc days or custom range) -->
                          @if (column?.filter?.type === 'date' && column?.filter?.visible) {
                            <div class="filter-selection-container date-selection-container">
                              <label>{{ column.name }}:</label>
                              <select #dateSelect (change)="this.cdr.detectChanges()">
                                <option disabled selected value="">Select Date Range</option>
                                <option value="custom">Custom Range</option>
                                <option value="7">Last 7 Days</option>
                                <option value="14">Last 14 Days</option>
                                <option value="30">Last 30 Days</option>
                                <option value="60">Last 60 Days</option>
                                <option value="90">Last 90 Days</option>
                              </select>
                              @if (dateSelect.value === 'custom') {
                                <div class="custom-range-inputs">
                                  <label>From:</label>
                                  <input #dateFrom type="date" (input)="this.cdr.detectChanges()" />
                                  <label>To:</label>
                                  <input #dateTo type="date" (input)="this.cdr.detectChanges()" />
                                  <div
                                    class="button button-green mt-3"
                                    (click)="
                                      setDateFilter(
                                        column,
                                        dateSelect.value,
                                        dateFrom.value,
                                        dateTo.value
                                      )
                                    "
                                    tabindex="0"
                                    (keydown.enter)="
                                      setDateFilter(
                                        column,
                                        dateSelect.value,
                                        dateFrom.value,
                                        dateTo.value
                                      )
                                    "
                                    [class.disabled]="
                                      dateFrom?.value === '' && dateTo?.value === ''
                                    "
                                  >
                                    Set Filter
                                  </div>
                                </div>
                              }
                              @if (dateSelect.value !== 'custom') {
                                <div
                                  class="button button-green"
                                  (click)="setDateFilter(column, dateSelect.value, null, null)"
                                  tabindex="0"
                                  (keydown.enter)="
                                    setDateFilter(column, dateSelect.value, null, null)
                                  "
                                  [class.disabled]="dateSelect.value === ''"
                                >
                                  Set Filter
                                </div>
                              }
                            </div>
                          }
                        </ng-container>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          @if (this.hasActiveSearch) {
            <span class="filter-active-text"
              ><img src="../../../../assets/images/Warning.svg" alt="warning icon" /> Active Search
              will be cleared</span
            >
          }
        </div>

        <!-- Edit Filter Buttons/Dropdowns -->
        @for (column of columns; track column) {
          <div
            class="dropdown selected-filter-dropdown"
            ngbDropdown
            [ngClass]="{ hidden: !column?.filter?.active }"
            id="{{ column.name }}"
            #activeFilter
            (openChange)="onActiveFilterClose(column.filter, activeFilter)"
          >
            @if (column?.filter?.active) {
              <div class="selected-filter" [ngClass]="{ disabled: isLoader() }">
                <!-- Filter type: string search -->
                <div class="filter-button" ngbDropdownToggle>
                  <span class="selected-title">{{ column.name }}</span>
                  <span class="material-symbols-outlined expand-icon">expand_more</span>
                </div>
                <span
                  class="material-symbols-outlined close-icon delete-filter"
                  (click)="removeFilter(column)"
                  tabindex="0"
                  (keydown.enter)="removeFilter(column)"
                  >close</span
                >
                @if (column?.filter?.type === 'string') {
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <div class="filter-options-container filter-selection-container">
                      <div class="alt-filter-container">
                        <label>{{ column.name }}:</label>
                        <input
                          #input
                          type="text"
                          class="filter-search"
                          placeholder=""
                          value="{{ column?.filter?.searchString }}"
                          (input)="this.cdr.detectChanges()"
                        />
                      </div>
                      <div
                        class="button button-green"
                        (click)="setStringFilter(column, input.value)"
                        tabindex="0"
                        (keydown.enter)="setStringFilter(column, input.value)"
                        [ngClass]="input.value === '' ? 'disabled' : ''"
                      >
                        Set Filter
                      </div>
                    </div>
                  </div>
                }
                <!-- Filter type: email search -->
                @if (column?.filter?.type === 'email') {
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <div class="filter-options-container filter-selection-container">
                      <div class="alt-filter-container">
                        <label>{{ column.name }}:</label>
                        <input
                          #input
                          type="email"
                          class="filter-search"
                          placeholder=""
                          value="{{ column?.filter?.searchString }}"
                          (input)="this.cdr.detectChanges()"
                        />
                      </div>
                      <div
                        class="button button-green"
                        (click)="setStringFilter(column, input.value)"
                        tabindex="0"
                        (keydown.enter)="setStringFilter(column, input.value)"
                        [ngClass]="input.value === '' ? 'disabled' : ''"
                      >
                        Set Filter
                      </div>
                    </div>
                  </div>
                }
                <!-- Filter type: checkboxes -->
                @if (column?.filter?.type === 'multipleChoice') {
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <div class="filter-options-container filter-selection-container">
                      <div class="alt-filter-container">
                        <label>{{ column.name }}:</label>
                        <ul>
                          @for (option of column?.filter?.options; track option; let i = $index) {
                            <li>
                              <label class="custom-check-container"
                                >{{ option.label }}
                                <input
                                  [(ngModel)]="option.checked"
                                  type="checkbox"
                                  [value]="option.key"
                                  #checkbox
                                />
                                <span class="checkmark"></span>
                              </label>
                            </li>
                          }
                        </ul>
                      </div>
                      <div
                        class="button button-green"
                        (click)="setCheckboxFilter(column, $event)"
                        tabindex="0"
                        (keydown.enter)="setCheckboxFilter(column, $event)"
                        [class.disabled]="!anyChecked(column)"
                      >
                        Set Filter
                      </div>
                    </div>
                  </div>
                }
                <!-- Filter type: number amount (exact, min, max) -->
                @if (column?.filter?.type === 'amount') {
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <div class="filter-options-container filter-selection-container">
                      <div class="alt-filter-container">
                        <!-- <label>Exact Value:</label>
                                <input #exact type="number" class="filter-search" value="{{column.filter.selectedAmounts.exact}}"> -->

                        <label>
                          <input
                            type="radio"
                            name="amountType"
                            value="exact"
                            #exactSelected
                            [checked]="column?.filter?.selectedAmounts?.exact !== ''"
                            (change)="changeAmountSelection(exactSelected, min, max, exact)"
                          />
                          Exact Value
                        </label>
                        <label>Amount</label>
                        <input
                          #exact
                          type="number"
                          class="filter-search amount-input"
                          value="{{ column?.filter?.selectedAmounts?.exact }}"
                          [disabled]="!exactSelected.checked"
                          (input)="this.cdr.detectChanges()"
                        />

                        <div class="or-container">
                          <hr />
                          <span>OR</span>
                        </div>
                        <!-- <label>Minimum Value:</label>
                                <input #min type="number" class="filter-search" value="{{column.filter.selectedAmounts.min}}">
                                <label>Maximum Value:</label>
                                <input #max type="number" class="filter-search" value="{{column.filter.selectedAmounts.max}}"> -->

                        <label>
                          <input
                            type="radio"
                            name="amountType"
                            value="range"
                            #rangeSelected
                            (change)="changeAmountSelection(rangeSelected, min, max, exact)"
                            [checked]="column?.filter?.selectedAmounts?.exact === ''"
                          />
                          Amount Range
                        </label>
                        <label>From</label>
                        <input
                          #min
                          type="number"
                          class="filter-search amount-input"
                          value="{{ column?.filter?.selectedAmounts?.min }}"
                          [disabled]="!rangeSelected.checked"
                          (input)="this.cdr.detectChanges()"
                        />
                        <label>To</label>
                        <input
                          #max
                          type="number"
                          class="filter-search mb-3 amount-input"
                          value="{{ column?.filter?.selectedAmounts?.max }}"
                          [disabled]="!rangeSelected.checked"
                          (input)="this.cdr.detectChanges()"
                        />
                      </div>
                      <div
                        class="button button-green"
                        (click)="setAmountFilter(column, exact.value, min.value, max.value)"
                        tabindex="0"
                        (keydown.enter)="setAmountFilter(column, exact.value, min.value, max.value)"
                        [class.disabled]="
                          min.value === '' && max.value === '' && exact.value === ''
                        "
                      >
                        Set Filter
                      </div>
                    </div>
                  </div>
                }
                <!-- Filter type: date (last 7,14, 30, etc days or custom range) -->
                @if (column?.filter?.type === 'date') {
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <div
                      class="filter-options-container date-selection-container filter-selection-container"
                    >
                      <div class="alt-filter-container">
                        <label>{{ column.name }}:</label>
                        <select
                          [value]="column?.filter?.dateType"
                          #dateSelect
                          (change)="this.cdr.detectChanges()"
                        >
                          <option disabled selected>Select Date Range</option>
                          <option value="custom">Custom Range</option>
                          <option value="7">Last 7 Days</option>
                          <option value="14">Last 14 Days</option>
                          <option value="30">Last 30 Days</option>
                          <option value="60">Last 60 Days</option>
                          <option value="90">Last 90 Days</option>
                        </select>
                        @if (dateSelect.value === 'custom') {
                          <div class="custom-range-inputs">
                            <label>From:</label>
                            <input
                              #dateFrom
                              type="date"
                              [value]="column.filter?.dateRange?.from | date: 'yyyy-MM-dd'"
                              (input)="this.cdr.detectChanges()"
                            />

                            <label>To:</label>
                            <input
                              #dateTo
                              type="date"
                              [value]="column.filter?.dateRange?.to | date: 'yyyy-MM-dd'"
                              (input)="this.cdr.detectChanges()"
                            />

                            <div
                              class="button button-green mt-3"
                              (click)="
                                setDateFilter(
                                  column,
                                  dateSelect.value,
                                  dateFrom.value,
                                  dateTo.value
                                )
                              "
                              tabindex="0"
                              (keydown.enter)="
                                setDateFilter(
                                  column,
                                  dateSelect.value,
                                  dateFrom.value,
                                  dateTo.value
                                )
                              "
                              [class.disabled]="!dateFrom.value && !dateTo.value"
                            >
                              Set Filter
                            </div>
                          </div>
                        }
                      </div>
                      @if (dateSelect.value !== 'custom') {
                        <div
                          class="button button-green"
                          (click)="setDateFilter(column, dateSelect.value, null, null)"
                          tabindex="0"
                          (keydown.enter)="setDateFilter(column, dateSelect.value, null, null)"
                        >
                          Set Filter
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Clear global search and/or all filters -->
    <div
      class="button button-clear"
      [ngClass]="{ disabled: (!this.hasActiveSearch && !this.hasActiveFilters) || isLoader() }"
      (click)="clearAll()"
      tabindex="0"
      (keydown.enter)="clearAll()"
    >
      <span class="material-symbols-outlined trash-icon"> &#xe872; </span>
      <!-- <div class="clear-filters">Clear Filters</div> -->
      <div class="clear-search">Clear {{ this.showingSearch ? 'Search' : 'Filters' }}</div>
    </div>
  </div>
</div>
